import { render, staticRenderFns } from "./InventoryStockOpnameReportPrint.vue?vue&type=template&id=b51b1e4a"
import script from "./InventoryStockOpnameReportPrint.vue?vue&type=script&lang=js"
export * from "./InventoryStockOpnameReportPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports